import React from 'react';
import { KeyboardDetectionContext } from '@spotify-internal/encore-web';
import { g as getEncoreStyles, D as DropdownIndicator, C as ClearIndicator, M as MultiValueRemove } from './MultiValueRemove-e34156ca.browser.esm.js';
export * from 'react-select';

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
// Otherwise default export is interpreted as a TS Namespace

var ReactSelect = require('react-select')["default"];

function Select(props, ref) {
  var _React$useContext = React.useContext(KeyboardDetectionContext),
      isUsingKeyboard = _React$useContext.isUsingKeyboard;

  return /*#__PURE__*/React.createElement(ReactSelect, _extends({}, props, {
    ref: ref,
    styles: getEncoreStyles({
      isUsingKeyboard: isUsingKeyboard,
      error: !!props.error,
      customStyles: props.styles
    }),
    components: _objectSpread({
      DropdownIndicator: DropdownIndicator,
      ClearIndicator: ClearIndicator,
      MultiValueRemove: MultiValueRemove
    }, props.components)
  }));
}

var Select$1 = /*#__PURE__*/React.forwardRef(Select);

export default Select$1;
